// removed by extract-text-webpack-plugin
module.exports = {"sortTitle":"_13Ogo9p4EoxNDjWmOIzPWz","sorterBlock":"ZPqmpM2oeQvTBacFp5-vO","orderSelect":"_2yymHW5dI24Ef-UpYIzhxQ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Playlists/components/PlaylistsSorter/PlaylistsSorter.scss
// module id = 1364
// module chunks = 1